import { Injectable } from '@angular/core'
import { FeathersService } from '../../feathers.service'
import { map } from 'rxjs/operators'
import { AssistanceStatus, AssistanceStatusName } from '../../../models/assistanceStatus'
import { CodeListService } from './CodeListService'
import { firstValueFrom, Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class AssistanceStatusesService extends CodeListService<AssistanceStatus> {
  recordClass = AssistanceStatus

  constructor(feathers: FeathersService) {
    super(feathers)
  }

  getByNames(names: AssistanceStatusName[]): Observable<AssistanceStatus[]> {
    return this.getAll().pipe(map((statuses) => statuses.filter((s) => names.includes(s.name))))
  }

  getByNameWithCache(name: AssistanceStatusName): Observable<AssistanceStatus> {
    return this.getAll().pipe(map((statuses) => statuses.find((s) => s.name === name)))
  }

  async getByIdOnce(id: number): Promise<AssistanceStatus> {
    return await firstValueFrom(this.getById(id))
  }

  public getPositiveStatusesOrdered() {
    return this.getAll().pipe(map((statuses) => AssistanceStatus.sortPositiveStatuses(statuses)))
  }
}
